// extracted by mini-css-extract-plugin
module.exports = {"OrderFooter":"OrderCreatePage_OrderFooter__3f2yw","ButtonRow":"OrderCreatePage_ButtonRow__1RCjz","Modal":"OrderCreatePage_Modal__236Gr"};